import Repository from "./Repository";
import LocalRepository from "./LocalRepository";

export default {

    login(email, password){
        return Repository.new().post("/login", {email: email, password: password});
    },
    register(username, email, password, force){
        return Repository.new().post("/register", {username: username, email:email, password: password, force:force});
    },
    verify(token){
        return Repository.new().get("/verify-account/"+token);
    },
    savePersonalDetails(username, email, emailNotifications){
        return Repository.new().post("/changedetails", {username: username, email:email, emailNotifications:emailNotifications});
    },
    changePassword(oldpassword, newpassword){
        return Repository.new().post("/changepassword", {oldpassword: oldpassword, newpassword:newpassword });
    },
    forgotPassword(email){
        return Repository.new().post("/forgot-password", {email: email});
    },
    recoverPasswordToken(password, recoverPasswordToken, securityToken){
        return Repository.new().post("/recover-password", {password: password, recoverPasswordToken: recoverPasswordToken, securityToken: securityToken});
    },
    changeImage(image){
        return Repository.new().post("/changeimage", {image: image});
    },
    sendReferral(email){
        return Repository.new().post("/referral", {email: email});
    },
    resendReferral(email){
        return Repository.new().post("/resend-referral", {email: email});
    },
    checkSentReferrals(){
        return Repository.new().post("/check-referrals");
    },
    getTransactions(){
        return Repository.new().get("/transactions");
    },

    async getMe(token = null){
        try{
            if (token) {
                let response = await Repository.new().auth(token).get("/me");
                if (response && response.data) {
                    return response.data.user;
                }
            } else if (LocalRepository.has('token')) {
                let response = await Repository.new().get("/me");
                if (response && response.data) {
                    return response.data.user;
                }
            }
        } catch (ignored) {
            return null;
        }
        return null;
    }

};